
export default [
  {
    title: 'Net Worth Calculator',
    description: `<p>Track your net worth and convert it to different currencies</p>`,
    skills: ['Node', 'React', 'TypeScript', 'TailwindCSS', 'Redis'],
    image: "net-worth-calc.png",
    links: {
      preview: "https://networth-calc.fly.dev",
      github: {
        React: 'https://github.com/AliNisarAhmed/net-worth-calc'
      },
    }
  },
  {
    title: 'Knight Movement Trainer',
    description: `<p>Chess Knight Movement Trainer app. Take the knight all the way to the end of the board while avoiding the enemy Queen. <a href="https://builtwithelm.co/?q=knight" target="_blank" ref="noopener noreferrer">Featured</a> on <a target="_blank" rel="noopener noreferrer" href="https://builtwithelm.co">Built with Elm</a>.</p>`,
    skills: ['Elm', 'Elm-ui'],
    image: "knightyknight.png",
    links: {
      preview: "https://knightyknight.netlify.app/",
      github: {
        Elm: 'https://github.com/AliNisarAhmed/knighty-knight'
      },
    }
  },
  {
    title: 'Game of Life',
    description: `<p>Game of life implementation, with two types of rules (default and Highlife). Built with Elm (A purely functional programming language for front-end development) and styled with elm-ui. (Current work in progress: design & UI improvements)</p>`,
    skills: ['Elm', 'Elm-ui'],
    image: "gol.png",
    links: {
      preview: "https://ecstatic-lewin-c9e2db.netlify.app/",
      github: {
        React: 'https://github.com/AliNisarAhmed/game-of-life'
      },
    }
  },
  {
    title: 'Periodic Table',
    description: `<p>A keyboard accessbile Periodic Table with features such as search, legend, temperature slider to show each element state, group and period highlighting. Styled with CSS Grid and Flexbox.</p>`,
    skills: ['React', 'TypeScript', 'Sass', 'Gatsby JS'],
    image: "periodic-table.png",
    links: {
      preview: "https://tableperiodic.netlify.app/",
      github: {
        React: 'https://github.com/AliNisarAhmed/periodic-table-ts-gatsby'
      },
    }
  },
  {
    title: 'Note',
    description: `<p>A Full-stack note-taking app. Built with React, TypeScript, Mongoose, and Express, using JWT for authentication. Primarily made to learn Docker Containers, the Database and the app are separate Docker containers ready to be deployed.</p>`,
    skills: ['React', 'TypeScript', 'Mongoose', 'Express', 'Materialize CSS', "Docker"],
    image: "note-app.png",
    links: {
      preview: "https://peaceful-temple-33603.herokuapp.com/",
      github: {
        React: 'https://github.com/AliNisarAhmed/note-taking-app'
      },
    }
  },
  {
    title: 'Portfolio',
    description: `<p>This web page! built with the amazing <a href="https://http://gatsbyjs.org/" target="_blank">Gatsby JS</a>. Styled with SCSS, and layout made with CSS Grid. The design of the portfolio was inspired by <a href="https://www.justinchi.me/">Justin's</a> design.</p>`,
    skills: ['React', 'Gatsby JS', 'SCSS', "CSS Grid"],
    image: "portfolio.png",
    links: {
      preview: "https://aliahmed.netlify.com/",
      github: {
        React: 'https://github.com/AliNisarAhmed/personal-portfolio'
      },
    }
  },
  {
    title: 'Zilch',
    description: `<p>A 2-player Dice game built with React (using the new state management technique, <a href="https://reactjs.org/docs/hooks-intro.html" target="_blank">React Hooks</a>) & CSS-in-JS library <a href="https://www.styled-components.com/" targt="_blank">styled-components</a>. I played this game long ago on a flash-player based gaming site but the game does not work now, so I decided to implement my own JS version.</p>`,
    skills: ['React', 'styled-components'],
    image: "zilch.jpg",
    links: {
      preview: "https://zilch-react.netlify.com/",
      github: {
        React: 'https://github.com/AliNisarAhmed/zilch-reactjs'
      },
    }
  },
  {
    title: 'Simon',
    description: `<p>Browser implementation of <a href="https://en.wikipedia.org/wiki/Simon_(game)" target="_blank">Simon</a> game, based off <a href="https://learn.freecodecamp.org/coding-interview-prep/take-home-projects/build-a-simon-game" target="_blank">this</a> challenge.</p>`,
    skills: ['React', 'TypeScript', 'Sass'],
    image: "simon.png",
    links: {
      preview: 'http://simon-react-tsc.netlify.com/',
      github: {
        React: 'https://github.com/AliNisarAhmed/simon-game-react'
      }
    }
  },
  {
    title: "Anonymous Message Board",
    description: `<p>A message board where anyone can discuss whatever they want, freely. I implemented the API as well as the Front-end as final <a href="https://learn.freecodecamp.org/information-security-and-quality-assurance/information-security-and-quality-assurance-projects/anonymous-message-board" target="_blank">challenge</a> of FreeCodeCamp's (FCC) Information Security and Quality Assurance Certification, which led to FCC's Full Stack Certification.</p>`,
    skills: ["React", "React-Router", "Express", "Mongoose", "Materialize CSS"],
    image: "anon.png",
    links: {
      preview: "https://morning-bayou-52638.herokuapp.com/",
      github: {
        React: "https://github.com/AliNisarAhmed/fcc-anon-msg-board"
      }
    }
  },
  {
    title: 'Wikipedia Viewer',
    description: `<p>Search for relevant articles from Wikipedia using the <a href="https://www.mediawiki.org/wiki/API:Main_page" target="_blank">wikimedia API</a>. I have implemented the same project in Vanilla JS, Vue & <a href="https://elm-lang.org/" target="_blank">Elm</a>. This was my first project with both Vue & Elm where I had to make Http requests and handle JSON response, using Axios in Vue, and <a href="https://package.elm-lang.org/packages/elm/json/latest/" target="_blank">JSON Decoders</a> in Elm.</p>`,
    skills: ["JS", "Vue", "Elm", "CSS3"],
    image: "wiki.png",
    links: {
      preview: "https://wiki-viewer-elm.netlify.com/",
      github: {
        JS: "https://github.com/AliNisarAhmed/wiki-viewer-vanilla",
        Vue: "https://github.com/AliNisarAhmed/wiki-viewer-vue",
        Elm: "https://github.com/AliNisarAhmed/wiki-viewer-elm",
      }
    }
  },
  {
    title: 'Hangman',
    description: `<p>Classic Hangman Game made with React. I also implemented the same project in TypeScript (React), Vue and Elm (This was my first Elm project)</p>`,
    skills: ["React", "TypeScript", "CSS3", "Vue", "Elm"],
    image: "hangman.png",
    links: {
      preview: "https://hangman-vue.netlify.com/",
      github: {
        React: "https://github.com/AliNisarAhmed/Hangman-React",
        TS: "https://github.com/AliNisarAhmed/hangman-react-tsc",
        Vue: "https://github.com/AliNisarAhmed/hangman-vue",
        Elm: "https://github.com/AliNisarAhmed/hangman-elm",
      }
    }
  },
  {
    title: "Memory game",
    description: `<p>Classic Memory (Uncover matching numbers) Game, implemented with React, using Sass for styling</p>`,
    skills: ['React', "Sass"],
    image: "memory.png",
    links: {
      preview: "https://github.com/AliNisarAhmed/memory-game-React",
      github: {
        React: "https://inspiring-hawking-627275.netlify.com/"
      }
    }
  },
  {
    title: "Exercise Tracker - API & Front-end",
    description: `<p>Exercise Tracker API, which keeps record of each user's exercise data, Last <a href="https://learn.freecodecamp.org/apis-and-microservices/apis-and-microservices-projects/exercise-tracker" target="_blank">Challenge</a> of FCC's APIs & MicroServices Certification. Later I re-implemented the same API with PostgreSQL as DB (using knexJS as SQL query builder).`,
    skills: ["Express", "MongoDB", "Mongoose", "PostgreSQL", "knexJS"],
    image: "exercise.png",
    links: {
      preview: "https://solstice-gibbon.glitch.me/",
      github: {
        MongoDB: "https://github.com/AliNisarAhmed/FCC-exercise-tracker",
        PostgreSQL: "https://github.com/AliNisarAhmed/fcc-exercise-tracker-pg",
      }
    }
  },
  {
    title: "Issue Tracker - API & Front-end",
    description: `<p>Built as <a href="https://learn.freecodecamp.org/information-security-and-quality-assurance/information-security-and-quality-assurance-projects/issue-tracker" target="_blank">part</a> of FCC's Information Security & Quality Assurance Certification, I initially implemented the project with MongoDB (using Mongoose as ODM), later on I re-implemented the API with PostgreSQL & knexJS. Front-end built with React & <a href="https://reach.tech/router" target="_blank">Reach-Router</a></p>`,
    skills: ["Express", "MongoDB", "Mongoose", "PostgreSQL", "React"],
    image: "issue.png",
    links: {
      preview: "https://fern-blizzard-1.glitch.me/",
      github: {
        MongoDB: "https://github.com/AliNisarAhmed/FCC-Issue-tracker",
        PostgreSQL: "https://github.com/AliNisarAhmed/fcc-issue-tracker-pg",
      }
    }
  },
  {
    title: "Stock Price Checker - API & Front-end",
    description: `<p>Users can fetch latest Stock Prices from <a href="https://iextrading.com/developer/" target="_blank">IEX API</a>. Also stores Likes by unique users (based on their IP). Uses fetch API to make Http requests, with MongoDB (<a href="https://mlab.com/" target="_blank">mLab</a>) as Database</p>`,
    skills: ["Express", "Mongoose"],
    image: "stock.png",
    links: {
      preview: "https://mud-draw.glitch.me/",
      github: {
        MongoDB: "https://github.com/AliNisarAhmed/fcc-stockprice-checker",
      }
    }
  },
  {
    title: "Tic Tac Toe",
    description: `<p>Two player Tic Tac Toe game, built with Vue, as well as React & Redux (this was my first Vue project as well as React-Redux project). The style of the app is based on <a href="https://scotch.io/tutorials/building-a-tic-tac-toe-game-with-vue-2-part-1" target="_blank">this</a> tutorial, however, the code is mine.</p>`,
    skills: ["React", "Redux", "Vue"],
    image: "tictactoe.png",
    links: {
      preview: "https://tictactoe-vue.netlify.com/",
      github: {
        React: "https://github.com/AliNisarAhmed/tictactoe-reactredux",
        Vue: "https://github.com/AliNisarAhmed/vue-TicTacToe",
      }
    }
  },
  {
    title: "D3 - Treemap Diagram",
    description: `<p>A Treemap Diagram showing Top selling movies in multiple genres. Area of each rectangle is proportional to the sales. Last <a href="https://learn.freecodecamp.org/data-visualization/data-visualization-projects/visualize-data-with-a-treemap-diagram" target="_blank">Challenge</a> of my hard-earned FCC's Data Visualization Certfication</p>`,
    skills: ["d3.js"],
    image: "treemap.png",
    links: {
      preview: "https://codesandbox.io/s/01zywq60l",
      github: {
        HTML: "https://github.com/AliNisarAhmed/fcc-d3-Treemap-withMenu",
      }
    }
  },
  {
    title: "D3 - Choropleth Map",
    description: `<p>Zoomable Map of United States depicting percentage of adults with a Bachelor's Degree or higher. <a href="https://learn.freecodecamp.org/data-visualization/data-visualization-projects/visualize-data-with-a-choropleth-map" target="_blank">Part</a> of FCC's Data Visualization Challenge</p>`,
    skills: ["d3.js"],
    image: "choropleth.png",
    links: {
      preview: "https://codesandbox.io/s/93r9kl8qxw",
      github: {
        HTML: "https://github.com/AliNisarAhmed/fcc-heatmap",
      }
    }
  },
  {
    title: "D3 - Heat Map",
    description: `<p>Visualization of Average Surface temperature data of the planet as Heat Map using <a href="https://learn.freecodecamp.org/data-visualization/data-visualization-projects/visualize-data-with-a-heat-map" target="_blank">d3.js</a>, as <a href="" target="_blank">part</a> of FCC's Data Visualization Certification</p>`,
    skills: ["d3.js"],
    image: "heatmap.png",
    links: {
      preview: "https://codesandbox.io/s/py23m8yjzj",
      github: {
        HTML: "https://github.com/AliNisarAhmed/fcc-heatmap",
      }
    }
  },
  {
    title: 'Product Landing Page',
    description: `<p>Landing page of a computer manufacturer, styled with Sass. A <a href="https://learn.freecodecamp.org/responsive-web-design/responsive-web-design-projects/build-a-product-landing-page" target="_blank">challenge</a> in FCC's Responsive Web Design certification.</p>`,
    skills: ['HTML5', "Sass"],
    image: 'productLanding.png',
    links: {
      preview: "https://product-landing-sass.netlify.com/",
      github: {
        HTML: "https://github.com/AliNisarAhmed/fcc-landingpage"
      }
    }
  },
  {
    title: "Pomodoro Clock",
    description: `<p>A Timer implementing <a href="https://en.wikipedia.org/wiki/Pomodoro_Technique" target="_blank">Pomodoro Technique</a> of time management, based off <a href="https://learn.freecodecamp.org/front-end-libraries/front-end-libraries-projects/build-a-pomodoro-clock" target="_blank">this</a> final challenge of FCC's Front-end Libraries Certification</p>`,
    skills: ["React", "Sass"],
    image: "pomodoro.png",
    links: {
      preview: "https://pomodoro-clock-react.netlify.com/",
      github: {
        React: "https://github.com/AliNisarAhmed/fcc-pomodoro-clock"
      }
    }
  },
  {
    title: "Calculator",
    description: `<p>JavaScript Calculator, a <a href="https://learn.freecodecamp.org/front-end-libraries/front-end-libraries-projects/build-a-javascript-calculator" target="_blank">challenge</a> from FCC's Front-end Libraries Certification</p>`,
    skills: ["React", "Sass"],
    image: "calc.png",
    links: {
      preview: "https://calculator-react-sass.netlify.com/",
      github: {
        React: "https://github.com/AliNisarAhmed/FCC-Calculator-React-Sass"
      }
    }
  },
  {
    title: "Drum Machine",
    description: `Sound Playing Drum Machine (responsive to both Keyboard and Clicks), built as part of <a href="https://learn.freecodecamp.org/front-end-libraries/front-end-libraries-projects/build-a-drum-machine" target="_blank">this</a> Challenge of FCC's Front-end Libraries Certification`,
    skills: ["React", "Sass"],
    image: "drum.png",
    links: {
      preview: "https://codesandbox.io/s/q4z3vvk0pj",
      github: {
        React: "https://github.com/AliNisarAhmed/fcc-drum-machine"
      }
    }
  },
  {
    title: "Markdown Previewer",
    description: `<p>Preview Markdown as you write, using marked library. Based off <a href="https://learn.freecodecamp.org/front-end-libraries/front-end-libraries-projects/build-a-markdown-previewer" target="_blank">this</a> challenge of FCC's Front-end Libraries Certification`,
    skills: ["React", "CSS3"],
    image: "markdown.png",
    links: {
      preview: "https://codesandbox.io/s/418y20p67",
      github: {
        React: "https://codesandbox.io/s/418y20p67"
      }
    }
  },
  {
    title: "Random Quote Machine",
    description: `<p>Get a new Random quote from an assortment of my favorite quotes I have collected over the years during my readings. First <a href="https://learn.freecodecamp.org/front-end-libraries/front-end-libraries-projects/build-a-random-quote-machine" target="_blank">challenge</a> of FCC's Front-end Libraries Certification.</p>`,
    skills: ["React"],
    image: "random.png",
    links: {
      preview: "https://csb-kjp8901v7-liukrptkou.now.sh/",
      github: {
        React: "https://codesandbox.io/s/kjp8901v7"
      }
    }
  },
  {
    title: "Technical Documentation Page",
    description: `<p>Mock of React JS Documentation, built with HTML5 and Sass for this <a href="https://learn.freecodecamp.org/responsive-web-design/responsive-web-design-projects/build-a-technical-documentation-page" target="_blank">challenge</a> of FCC's Responsive Web Design Certification</p>`,
    skills: ["HTML", "Sass"],
    image: "technical.png",
    links: {
      preview: "https://codepen.io/AA87/pen/YOqNgM/",
      github: {
        HTML5: "https://codepen.io/AA87/pen/YOqNgM/",
      }
    }
  },
  {
    title: "Slack - Front-end",
    description: `<p>A simplified Slack front-end built as an exercise in the book <a href="https://daveceddia.com/pure-react/" target="_blank">Pure React</a> by Dave Ceddia. My first project with React.</p>`,
    skills: ["React", "Sass"],
    image: "slack.png",
    links: {
      preview: "https://codesandbox.io/s/883vnox858",
      github: {
        HTML: "https://github.com/AliNisarAhmed/PureReact-Slack",
      }
    }
  },
]
